import React, { useState, useEffect } from 'react';
import { Tooltip, withStyles } from '@material-ui/core';
import CustomSelect from '../CustomSelect/CustomSelect';
import { findAllTag } from '../../services/TagService';

const TagSelect = ({ value, onChange, className, classes }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const loadInitialTags = async () => {
      try {
        const response = await findAllTag({
          search: '',
          pageableDTO: { pageNumber: 0, pageSize: 100 },
          ativo: true,
        });
        setOptions(response.content || []);
      } catch (error) {
        console.error('Erro ao carregar tags:', error);
      }
    };
    loadInitialTags();
  }, []);

  return (
    <Tooltip title={value?.nome || "Selecionar tag"} placement="top">
      <div className={className}>
        <CustomSelect
          value={value}
          onChange={onChange}
          options={options}
          controlWidth={52}
          controlHeight={30}
          menuWidth={160}
          dropdownIndicatorSize={12}
          dropdownIndicatorPadding={2}
          showIndicatorSeparator={false}
          getOptionLabel={(option) => (
            <div className={classes.optionLabel}>
              <div
                className={classes.colorCircle}
                style={{ backgroundColor: option.cor }}
              />
              {option.nome}
            </div>
          )}
          getOptionValue={(option) => option.id}
          components={{
            SingleValue: ({ data }) => (
              <div
                className={classes.singleValueCircle}
                style={{ backgroundColor: data.cor }}
              />
            ),
            IndicatorSeparator: () => null
          }}
          controlStyles={{
            border: 'none',
            boxShadow: 'none',
            backgroundColor: '#F2F2F2',
            borderRadius: '8px',
            cursor: 'pointer',
          }}
          valueContainerStyles={{
            padding: '0',
            justifyContent: 'center'
          }}
          placeholder=""
          isClearable
          cacheOptions
          defaultOptions
          clearIndicatorSize={10}
          clearIndicatorPadding={2} 
          isSearchable={false}
        />
      </div>
    </Tooltip>
  );
};

const styles = {
  optionLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  colorCircle: {
    width: '12px',
    height: '12px',
    borderRadius: '50%'
  },
  singleValueCircle: {
    width: '12px',
    height: '12px',
    borderRadius: '50%'
  }
};

export default withStyles(styles)(TagSelect);